<template>
  <div class="potvrda-email forma-erp">
    <v-row justify="center" class="mt-8">
      <v-col cols="12" sm="10" md="6" lg="5" style="max-width:520px">
        <v-card outlined>
          <v-card-title class="naslov-kartice">
            {{ uspjeh ? 'E-mail potvrđen / E-mail confirmed' : 'Potvrda registracije / Confirm registration' }}
          </v-card-title>
          <v-card-text class="tijelo text-center">
            <v-progress-circular
              v-if="provjeravam"
              indeterminate
              color="primary"
              size="40"
              class="my-4"
            ></v-progress-circular>

            <v-icon v-if="!provjeravam && uspjeh" color="green" size="56" class="my-2">mdi-check-circle-outline</v-icon>
            <v-icon v-if="!provjeravam && !uspjeh" color="orange darken-2" size="56" class="my-2">mdi-alert-circle-outline</v-icon>

            <div class="poruka">{{ poruka }}</div>

            <v-btn color="primary" class="mt-5" @click="naPrijavu">
              Prijava / Login
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UserService from '@/services/UserService'

export default {
  name: 'userconfirmemail',
  data () {
    return {
      provjeravam: true,
      uspjeh: false,
      poruka: ''
    }
  },
  async mounted () {
    const token = this.$route.params.token
    if (!token) {
      this.provjeravam = false
      this.poruka = 'Neispravna poveznica. / Invalid link.'
      return
    }
    try {
      const odgovor = await UserService.confirmEmail(token)
      this.uspjeh = true
      this.poruka = odgovor && odgovor.data && odgovor.data.message
        ? odgovor.data.message
        : 'E-mail je potvrđen. / E-mail confirmed.'
    } catch (greska) {
      // Posluzitelj razlikuje istekao, vec iskoristen i neispravan token;
      // njegovu poruku prenosimo kakva jest.
      const odgovor = greska && greska.response ? greska.response : null
      this.poruka = odgovor && odgovor.data && odgovor.data.message
        ? odgovor.data.message
        : 'Potvrda nije uspjela. Pokušajte ponovno. / Confirmation failed. Please try again.'
    }
    this.provjeravam = false
  },
  methods: {
    naPrijavu () {
      this.$router.push({ path: '/' }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.potvrda-email .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 16px;
  min-height: 0;
}
.potvrda-email .tijelo {
  padding: 18px 20px 22px;
}
.potvrda-email .poruka {
  font-size: 15px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.87);
}
</style>
